import { ParametersListAPI } from 'ducks/types/api-types';
import { normalizeObjUUID } from 'ducks/utils';
import moment from 'moment';

import 'moment-duration-format';

export function normalizeTimeout(timeout = 0) {
  const hours = Math.floor(timeout / 3600);
  const minute_seconds = timeout % 3600;
  const minutes = Math.floor(minute_seconds / 60);
  const seconds = minute_seconds % 60;

  let timeout_format = '';

  if (hours !== 0) {
    timeout_format += `${hours}h`;
  }
  if (minutes !== 0) {
    timeout_format += ` ${minutes}m`;
  }
  if (seconds !== 0) {
    timeout_format += ` ${seconds}s`;
  }

  return timeout_format;
}

export function normalizeSeconds(date: number, format = 's[sec]') {
  return moment.duration(date, 'seconds').format(format);
}

export function normalizeParameters(parameters: ParametersListAPI[]) {
  return parameters.map((parameter) =>
    normalizeObjUUID({
      ...parameter,
      parameter_name_old: parameter.parameter_name,
      modified: false,
      saved: true,
    }),
  );
}
